import React from "react";
import "./TermsAndRefund.css";

const TermsAndRefund = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Use and Refund Policy</h1>

      <h2>Terms of Use</h2>

      <h3>Introduction</h3>
      <p>
        Welcome to <strong>Jyotirvani.com</strong>. By using this website, you
        agree to comply with and be bound by the following terms and conditions.
        Please read these terms carefully before using the website. If you
        disagree with any part of these terms, you should not use the website.
      </p>

      <h3>Use of Website</h3>
      <ul>
        <li><strong>Eligibility:</strong> You must be at least 18 years of age to use our services or access the content on this website. By using the website, you confirm that you meet this age requirement.</li>
        <li><strong>Personal Use:</strong> The content on Jyotirvani.com is for personal, non-commercial use only. You may not reproduce, distribute, or exploit any content without our explicit permission.</li>
        <li><strong>Account Security:</strong> You are responsible for maintaining the confidentiality of your account credentials.</li>
        <li><strong>Accuracy of Information:</strong> While we strive for accuracy, we do not guarantee completeness or accuracy of all content.</li>
        <li><strong>Services Provided:</strong> Our astrology-related services are for informational purposes only and are not professional or medical advice.</li>
      </ul>

      <h3>User Responsibilities</h3>
      <ul>
        <li><strong>Compliance:</strong> You agree to comply with all applicable laws.</li>
        <li><strong>Prohibited Use:</strong> Do not engage in illegal, unethical, or harmful activities on the site.</li>
        <li><strong>Content Submission:</strong> Submitted content may be used and modified by Jyotirvani.com under a royalty-free license.</li>
      </ul>

      <h3>Limitation of Liability</h3>
      <ul>
        <li><strong>Service Availability:</strong> We do not guarantee uninterrupted service and are not liable for any outages.</li>
        <li><strong>No Liability:</strong> We are not responsible for any indirect or consequential damages.</li>
      </ul>

      <h3>Amendments to Terms</h3>
      <p>
        Jyotirvani.com reserves the right to update these Terms of Use. Continued use of the website constitutes acceptance of the updated terms.
      </p>

      <h2>Refund Policy</h2>
      <p>
        We are committed to ensuring your satisfaction. Please read our refund policy carefully before making a purchase.
      </p>

      <h3>1. Astrology Consultation Services</h3>
      <ul>
        <li>Non-refundable once the consultation has been conducted.</li>
        <li>If dissatisfied, contact our support team to resolve your concern.</li>
        <li>Full refunds may be given for cancellations made at least 24 hours in advance.</li>
        <li>No refunds for cancellations within 24 hours of the scheduled session.</li>
      </ul>

      <h3>2. Digital Products and Courses</h3>
      <ul>
        <li>Non-refundable once accessed, downloaded, or viewed.</li>
        <li>If technical issues prevent access, contact us. Refunds are considered only after support efforts fail.</li>
      </ul>

      <h3>3. Gemstone and Crystal Purchases</h3>
      <ul>
        <li>All sales are final due to custom energization and rituals.</li>
        <li>Refunds are not provided for dissatisfaction, belief, or result-based reasons.</li>
        <li>Damaged or incorrect items must be reported within 48 hours with photo/video proof. Replacements or partial refunds may be issued after verification.</li>
      </ul>

      <h3>4. Refund Request Procedure</h3>
      <p>Email us at <strong>support@jyotirvani.com</strong> with:</p>
      <ul>
        <li>Your order ID</li>
        <li>A brief explanation of the issue</li>
        <li>Photos/videos if applicable</li>
      </ul>
      <p>We will respond within 2-3 business days. Approved refunds will be processed within 7-10 business days.</p>

      <h3>5. Exceptions</h3>
      <ul>
        <li>Custom-made products, personalized reports, and energized items are non-refundable.</li>
        <li>Shipping charges are non-refundable unless the product is damaged or incorrect.</li>
      </ul>

      <p>
        By purchasing on <a href="https://www.jyotirvani.com" target="_blank" rel="noopener noreferrer">jyotirvani.com</a>, you agree to the terms and conditions
        of this Refund Policy.
      </p>
    </div>
  );
};

export default TermsAndRefund;
